import { create } from 'zustand';

interface FeedbackStore {
  isFeedbackDialogOpen: boolean;
  openFeedbackDialog: () => void;
  closeFeedbackDialog: () => void;
}

export const useFeedbackStore = create<FeedbackStore>(set => ({
  isFeedbackDialogOpen: false,
  openFeedbackDialog: () => set({ isFeedbackDialogOpen: true }),
  closeFeedbackDialog: () => set({ isFeedbackDialogOpen: false }),
}));
